<template>
  <info-form @submit="addEnrollStudent"></info-form>
</template>
<script>
import InfoForm from "./InfoForm";
import { service_names } from "@/constants/Services";
export default {
  components: { InfoForm },
  data() {
    return {};
  },
  props: ["addEnrollmentModalName"],
  methods: {
    addEnrollStudent(form) {
      const studentId = this.$route.params.id;
      this.$axios
        .post(`${service_names.user}/enrollment`, {
          ...form,
          student_id: studentId
        })
        .then(() => {
          this.$modal.hide(this.addEnrollmentModalName);
          this.$emit("rerenderTable");
        });
    }
  }
};
</script>
